const decompressSensorData = (compressedData = []) => {
    if (!compressedData || compressedData.length === 0) {
        return compressedData;
    }

    // 1. 숫자 데이터 복원
    const numberRestoredData = restoreNumberData(compressedData);

    // 2. 시간 데이터 복원
    const timeRestoredData = restoreTimeData(numberRestoredData);

    // 3. 필드 이름 복원
    const restoredData = restoreFieldNames(timeRestoredData);

    return restoredData;
}

const restoreNumberData = (compressedData = []) => {
    // 숫자 데이터는 이미 최적화된 형태로 사용 가능하므로 그대로 반환
    return compressedData;
}

const restoreTimeData = (compressedData = []) => {
    return compressedData.map(item => {
        const restoredItem = { ...item };

        // 시간 필드 복원
        if (item.rt && typeof item.rt === 'number') {
            try {
                // 타임스탬프를 ISO 문자열로 변환
                restoredItem.rt = new Date(item.rt).toISOString();
            } catch (error) {
                console.warn('시간 데이터 복원 오류:', error);
            }
        }

        return restoredItem;
    });
}

const restoreFieldNames = (compressedData = []) => {
    const reverseFieldMapping = {
        'sid': 'SENACT_ID',
        'snm': 'SENACT_NM',
        'sdo': 'SENACT_DETAIL_VAL_ORDER',
        'sdt': 'SENACT_DETAIL_VAL_TITLE',
        'sdu': 'SENACT_DETAIL_VAL_UNIT',
        'rt': 'rounded_time',
        'av': 'avg_val',
        'svh': 'SENACT_VAL_HI',
        'svl': 'SENACT_VAL_LOW'
    };

    return compressedData.map(item => {
        const restoredItem = {};

        // 필드 매핑에 따라 복원
        Object.keys(item).forEach(key => {
            const originalKey = reverseFieldMapping[key] || key;
            restoredItem[originalKey] = item[key];
        });

        return restoredItem;
    });
}

export const CompressionService = () => {
    return decompressSensorData;
}
